import { render, staticRenderFns } from "./carRecognition.vue?vue&type=template&id=ba2e057c&scoped=true"
import script from "./carRecognition.vue?vue&type=script&lang=js"
export * from "./carRecognition.vue?vue&type=script&lang=js"
import style0 from "./carRecognition.vue?vue&type=style&index=0&id=ba2e057c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba2e057c",
  null
  
)

export default component.exports